<script>
import EvaluateForm from './EvaluateForm/index'
import { submitInspect, modifyInspect, submitCurate, getReovkePunishNotice } from './api'
import { convertArraysToStrings } from '@/utils/tool'
import { getInspectJudgeType } from "@/modules/entities"
import moment from 'moment'
function getJudgeForm () {
  return ({
    judge_status: undefined,
    judge_type: [],
    judge_content: undefined,
    curators: [],
    filename: undefined,
    judge_file: undefined,
  })
}
function getPunishForm () {
  return ({
    violation_user_ids: [],
    violation_manager_ids: [],
    punish_date: moment().format('YYYY-MM-DD'),
    punish_amount: undefined,
    dismiss: undefined,
    punish_content: undefined,
    filename: undefined,
    punish_file: undefined,
    punish_notice: undefined,
    punish_notice_content: undefined,
  })
}
function  getNewListItem () {
  let judgeForm = getJudgeForm()
  // 获取一个随机hashId
  let hashId = Math.random().toString(36).substring(2, 9)
  return {
    hashId,
    judgeForm,
      // 页面编辑元素
    judgeEditable: true,
    punishEditable: false,
    punishFromShow: false,
  }
}
export default {
  components: { EvaluateForm },
  props: {
    hasEditPermission: Boolean,
    alreadyJudge: Boolean,
    detail: Object,
    validOptions: Array,
    comfirmTableList: Array,
    chatList: Array,
  },
  data () {
    return {
      list: [],
      btnLoading: false,
    }
  },
  computed: {
    validLeders() {
      // 关联负责人
      return Object.values(
        this.validOptions.filter(item => item.leder && item.leder.id)
          .reduce((acc, cur) => {
            acc[cur.leder.id] = cur.leder
            return acc
          }, {})
        )
    },
    validEmployeesMap() {
      return this.validOptions.filter(item => item.employee && item.employee.id)
        .reduce((acc, cur) => {
          acc[cur.employee.id] = {
            ...cur.employee,
            full_name: cur.employee.fullName,
            leder: cur.leder
          }
          return acc
        }, {})
    },
    validEmployees () {
      return Object.values(this.validEmployeesMap)
    },
    allSelectedCurators () {
      return this.list.reduce((arr, cur) => {
        arr.push(...cur.judgeForm?.curators)
        return arr
      }, [])
    },
    optionalCurators() {
      return item => {
        let selectedValue = []
        this.list.forEach(listItem => {
          if (listItem === item) return
          selectedValue.push(...listItem.judgeForm.curators)
        })
        return this.validLeders.filter(item => !selectedValue.includes(item.value))
      }
    },
    judgeFromOptions() {
      return item => ([
        { label: '', prop: 'judge_status', type: 'ButtonTab', propOptions: {
          options: [
            { label: '无异常', value: 1, type: 'success' },
            { label: '需整改', value: 3, type: 'primary' },
            { label: '违规', value: 2, type: 'danger' },
          ]}, rules: [
            { required: true, message: '请选择评定结果', trigger: 'change' }
          ]
        },
        { label: '违规类别:', labelWidth: '70px', prop: 'judge_type', type: 'Type', propOptions: {
            options: getInspectJudgeType(),
          },
        },
        { label: '', prop: 'judge_content', type: 'EditInput', propOptions: {
            type: 'textarea',
            placeholder: '情况说明',
            rows: 5,
          }, rules: [
            { required: true, message: '请输入情况说明', trigger: 'change' }
          ]
        },
        { label: '关联负责人:', labelWidth: '80px', prop: 'curators', type: 'SelectTag', propOptions: {
            options: this.optionalCurators(item),
            valueKey: 'id',
            labelKey: 'full_name',
            valueOptions: item.curators,
            filterOptions: this.allSelectedCurators,
            showIsread: true,
          }, rules: [
            { required: true, message: '请选择关联负责人', trigger: 'blur' }
          ]
        },
        { label: '', prop: 'judge_file', type:'Upload', propOptions: {
          nameProp: 'filename'
        }}
      ])
    },
    punishFromOptions() {
      let selectOptions = [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ]

      let getType = (item, type) => {
        return item.punishEditable ? type : 'text'
      }
      
      let optionsArr = item => ([
        { label: '违规人：', prop: 'violation_user_ids', type: 'SelectTag', propOptions: {
            remote: false,
            valueKey: 'id',
            labelKey: 'full_name',
            options: this.validEmployees,
            valueOptions: item.punishInfo?.violation_users || [],
          },
          rules: [
            { required: true, message: '请选择违规人', trigger: 'blur' }
          ]
        },
        { label: '关联管理层：', prop: 'violation_manager_ids', type: 'SelectTag', propOptions: {
            options: this.validLeders,
            valueKey: 'id',
            labelKey: 'full_name',
            valueOptions: item.punishInfo?.violation_managers || [],
          },
          rules: [
            { required: true, message: '请选择关联管理层', trigger: 'blur' }
          ]
        },
        { label: '处罚日期：', prop: 'punish_date', type: getType(item, 'el-date-picker'), showTextProp: 'punishInfo.punish_date', propOptions: {
            type: "date",
            placeholder: '选择日期',
            valueFormat: 'yyyy-MM-dd',
            style: 'width: 193px'
          },
          rules: [
            { required: true, message: '请选择处罚日期', trigger: 'change' }
          ]
        },
        { label: '合规处罚金额：', prop: 'punish_amount', type: getType(item, 'el-input-number'), propOptions: {
            precision: 2,
            controls: false,
            class: 'lh24',
            min: 0,
            style: 'width: 100px'
          },
          format: () => `${item.punishInfo?.punish_amount || '--'} 元`,
          rules: [
            { required: true, message: '请输入处罚金额：', trigger: 'blur' }
          ]
        },
        { label: '是否解除劳动合同：', prop: 'dismiss', type: getType(item, 'el-select'), propOptions: {
            placeholder: '请选择',
            options: selectOptions,
          },
          format: () => item.punishInfo?.dismiss ? '是' : '否',
          rules: [
            { required: true, message: '请选择是否解除劳动合同：', trigger: 'change' }
          ]
        },
        { label: '备注：', prop: 'punish_content', type: 'EditInput', showTextProp: 'punishInfo.punish_content', propOptions: {
            type: 'textarea',
            placeholder: '请输入',
            rows: 5,
          }
        },
        { label: '', prop: 'punish_file', type:'Upload', labelWidth: '0', propOptions: {
          nameProp: 'filename',
          labelStyle: 'width: 150px;text-align:right;'
        }},
        {
          label: '钉钉消息：', prop: 'punish_notice_reovke', type: 'slot',
          show: (item) => item.punishEditable && (item.punishInfo?.task_id && item.hidePunishNotice),
        },
        { label: '是否发送钉钉消息：', prop: 'punish_notice', type: 'el-select',
          show: (item) => item.punishEditable && !item.hidePunishNotice,
          propOptions: {
            placeholder: '请选择',
            options: selectOptions,
          },
          rules: [
            { required: true, message: '请选择是否发送钉钉消息：', trigger: 'change' }
          ]
        },
        { label: '消息内容：', prop: 'punish_notice_content', type: 'EditInput',
          show: (item) => item.punishEditable && !item.hidePunishNotice && item.punishForm.punish_notice,
          propOptions: {
            type: 'textarea',
            placeholder: '请输入',
            rows: 5,
          }
        },
      ])
      
      return (item) => {
        return optionsArr(item).filter(a => !a.show || a.show(item))
      }
    },
  },
  watch: {
    'detail': {
      handler(val) {
        if (val.judges && val.judges.length) {
          let list = val.judges.map(item => {
            // 稽查表单
            let judgeForm = getJudgeForm()
            this.onFormInit(judgeForm, item, {
              filename: 'judge_filename'
            })
            
            // 处罚结果表单
            let punishForm = getPunishForm()
            let punishFromShow = false
            let hasPunishInfo = false // 是否提交过处罚结果
            let hidePunishNotice = false // 处罚结果编辑时，是否隐藏【是否发送钉钉消息】

            if (Object.prototype.toString.call(item.punishInfo) === '[object Object]') {
              this.onFormInit(punishForm, item.punishInfo, {
                filename: 'punish_filename',
                violation_user_ids: 'violation_users',
                violation_manager_ids: 'violation_managers',
              })
              // task_id
              hasPunishInfo = hidePunishNotice = punishFromShow = true
            }
            return {
              ...item,
              judgeForm,
              punishForm,
              judgeEditable: !this.alreadyJudge, // 提交过稽查结果，关闭编辑状态
              punishFromShow,
              hidePunishNotice,
              punishEditable: false,
              hasPunishInfo,
            }
          })
          this.list = list
        } else {
          this.list = [ getNewListItem() ]
        }
      },
      immediate: true
    },
    'validOptions': {
      handler() {
        this.list?.forEach(item => {
          if (item.punishEditable) {
            this.filterValidEmployees(item.punishForm)
          }
        })
      },
      immediate: false
    }
  },
  methods: {
    filterValidEmployees (item) {
      // 只保留已稽查的员工
      item.violation_user_ids = item.violation_user_ids
        .filter(value => this.validEmployees.find(obj => obj['id'] == value))
    },
    onFormInit(form, data, replaceKeysMap = {}) {
      let userKey = [ 'curators', 'violation_manager_ids', 'violation_user_ids']
      Object.keys(form).forEach(key => {
        let replaceKey = key
        if (replaceKeysMap[key]) {
          replaceKey = replaceKeysMap[key]
        }
        if (userKey.includes(key)) {
          form[key] = data[replaceKey]?.map(item => item.id) || []
        } else {
          form[key] = (data[replaceKey] || data[replaceKey] === 0) ? data[replaceKey] : form[key]
        }
        if (key === 'punish_date' && data[key] === '0000-00-00') {
          form[key] = moment().format('YYYY-MM-DD')
        }
      })
    },
    onSubmitInspection ({ isCache = 2 } = {}) {
      this.onSubmit({
        refName: 'refJudgeFrom',
        api: submitInspect,
        getParams: () => {
          const judge_form = this.list.map(a => convertArraysToStrings(a.judgeForm))
          // let marks = this.comfirmTableList?.map(item => ({
          //   contact_id: item.contact_id,
          //   employee_id: item.employee_id,
          //   mark_ids: item.mark_ids
          // })) || []
          let marks = this.comfirmTableList?.map(item => {
            let contact_id = item.contact_id
            let employee_id = item.employee_id
            let mark_ids = this.chatList?.filter(chatItem => (
              chatItem.contact?.id === contact_id &&
              chatItem.employee?.id === employee_id
            ))?.map(a => a.id) || []
            return {
              contact_id,
              employee_id,
              mark_ids
            }
          })
          let chatList = this.chatList?.map(item => ({
            contact_id: item.contact?.id,
            employee_id: item.employee?.id,
            id: item.id
          }))
          const params = {
            judge_form: JSON.stringify(judge_form),
            id: this.detail.id,
            isCache,
            marks: JSON.stringify(marks),
            chatList: JSON.stringify(chatList),
          }
          return params
        },
        successMsg: isCache === 1 ? '暂存成功' : ''
      })
    },
    onSubmitItemInspection({item, refIndex} = {}) {
      this.onSubmit({
        refName: 'refJudgeFrom',
        refIndex,
        api: modifyInspect,
        getParams: () => {
          const params = {
            id: item.id,
            ...item.judgeForm,
            isCache: 2,
          }
          return params
        },
      })
    },
    onSubmitItemPunish({item, refIndex} = {}) {
      this.onSubmit({
        refName: 'refPunishFrom',
        refIndex,
        api: submitCurate,
        getParams: () => {
          const params = {
            id: item.id,
            ...item.punishForm,
          }
          if (!params.punish_notice) {
            delete params.punish_notice_content
          }
          delete params.punish_notice
          delete params.punish_notice_reovke
          return params
        },
      })
    },
    async onSubmit({refName, refIndex, api, getParams, successMsg} = {}) {
      const refArr = this.$refs[refName]
      if (refIndex || refIndex === 0) {
        await refArr[refIndex].validate()
      } else {
        let len = refArr.length
        for (let i = 0; i < len; i++) {
          await refArr[i].validate()
        }
      }
      try {
        this.btnLoading = true
        const {code, msg} = await api(getParams())
        if (code !== 200) {
          throw new Error(msg)
        }
        this.$message.success(successMsg || '提交成功')
        this.$emit('update')
      } catch (e) {
        this.$message.error(e.message || e)
      } finally {
        this.btnLoading = false
      }
      
    },
    onInspectionEidt (item) {
      item.judgeEditable = true
      this.oldJudgeFormStr = JSON.stringify(item.judgeForm)
      this.changeJudgeEditable()
    },
    CancelInspectionEdit (item) {
      item.judgeEditable = false
      // 恢复旧数据， 从接口中获取
      item.judgeForm = JSON.parse(this.oldJudgeFormStr)
      this.changeJudgeEditable()
    },
    changeJudgeEditable () {
      const editable = this.list.some(item => item.judgeEditable)
      this.$emit('changeJudgeEditable', editable)
    },
    onPunishEdit (item) {
      item.punishEditable = true
      item.punishFromShow = true
      // 违规人 + 关联管理层默认值
      if (!item.hasPunishInfo && this.validEmployees?.length) {
        let fristUserIds = this.validEmployees[0].id
        if (!fristUserIds) return
        item.punishForm.violation_user_ids = [fristUserIds]
        let leaderId = this.validEmployeesMap[fristUserIds]?.leder?.id
        if (leaderId) {
          item.punishForm.violation_manager_ids = [leaderId]
        }
      }
      this.filterValidEmployees(item.punishForm)
    },
    CancelPunishEdit (item) {
      item.punishEditable = false
      if (!item.hasPunishInfo) {
        item.punishFromShow = false
      }
    },
    onAdd (index) {
      let item = getNewListItem()
      this.list.splice(index+1, 0, item)
    },
    onDel (index) {
      this.list.splice(index, 1)
    },
    async reovkePunishNotice(item) {
      try {
        this.btnLoading = true
        let { code } = await getReovkePunishNotice({
          punish_info_id: item.punishInfo.id
        })
        if (code === 200) {
          this.$message.success('撤销成功')
          item.hidePunishNotice = false
          item.punishForm.punish_notice = 1
        }
      } finally {
        this.btnLoading = false
      }
    }
  }
}
</script>

<template>
  <div>
    <div 
      :class="$style.module"
      v-for="(item, index) in list"
      :key="item.hashId || item.id"
    >
      <div :class="$style.moduleTitle" v-if="alreadyJudge || !index">稽查结果评定{{item.judgeEditable ? '' : '记录'}}</div>
      <EvaluateForm
        v-model="item.judgeForm"
        hide-required-asterisk
        label-position="left"
        :data="item"
        ref="refJudgeFrom"
        :options="judgeFromOptions(item)"
        :editable="item.judgeEditable && hasEditPermission"
      />
      <template v-if="item.punishFromShow">
        <div :class="$style.moduleTitle">处罚结果</div>
        <EvaluateForm
          v-model="item.punishForm"
          :data="item"
          ref="refPunishFrom"
          label-width="150px"
          :options="punishFromOptions(item)"
          :editable="item.punishEditable && hasEditPermission"
        >
          <template #self="{ config }">
            <div v-if="config.prop === 'punish_notice_reovke'">
              <div style="display: inline-flex;white-space: pre-line;max-width: 80%;">{{ item.punishInfo.punish_notice_content }}</div>
              <el-button class="ml5 fs14 p0" type="text" @click="reovkePunishNotice(item)" :loading="btnLoading">[撤回消息]</el-button>
            </div>
          </template>
        </EvaluateForm>
        <div class="ml150" v-if="!item.punishEditable">
          <el-button class="p6 pr25 pl25" @click="onPunishEdit(item)">编辑</el-button>
          <div class="fs14 lh26 mt30" v-if="item.punishInfo && item.punishInfo.edit_logs">
            <div>编辑记录：</div>
            <div v-for="(logItem, logIndex) in item.punishInfo.edit_logs" :key="logIndex">
              <span>{{ logItem.time }}</span>
              <span class="ml10 mr10">{{ logItem.openater }}</span>
              <span>{{ logItem.edit_content }}</span>
            </div>
          </div>
        </div>
      </template>
      <div :class="$style.addAndDelBox" v-if="!alreadyJudge">
        <template v-if="hasEditPermission">
          <span
            v-if="index === list.length - 1"
            :class="$style.addBtn"
            @click="onAdd(index)"
          >
            <i class="el-icon-document-add"></i>
            <span>添加结果评定</span>
          </span>
          <span 
            :class="$style.delBtn"
            v-if="list.length > 1"
            @click="onDel(index)"
          >
            <i class="el-icon-delete"></i>
            <span>删除</span>
          </span>
        </template>
      </div>

      <template v-else-if="item.punishFromShow">
        <div :class="$style.btns" v-if="item.punishEditable">
          <el-button @click="CancelPunishEdit(item)" :loading="btnLoading">返回</el-button>
          <el-button key="submit__penaltyFrom" v-if="hasEditPermission" @click="onSubmitItemPunish({item, refIndex: index})" :loading="btnLoading">提交</el-button>
        </div>
      </template>

      <div :class="$style.btns" v-else-if="!item.judgeEditable">
        <el-button v-if="hasEditPermission" key="edit__punishFrom" @click="onPunishEdit(item)" :loading="btnLoading">提交处理结果</el-button>
        <el-button v-if="hasEditPermission" key="edit__inspectionFrom" @click="onInspectionEidt(item)" :loading="btnLoading">编辑</el-button>
      </div>
      
      <div :class="$style.btns" v-else>
        <el-button @click="CancelInspectionEdit(item)" :loading="btnLoading">返回</el-button>
        <el-button v-if="hasEditPermission" key="submit__inspectionFrom" @click="onSubmitItemInspection({item, refIndex: index})" :loading="btnLoading">提交</el-button>
      </div>
    </div>
    <div :class="$style.btns" v-if="!alreadyJudge">
      <el-button @click="$emit('back')" :loading="btnLoading">返回</el-button>
      <el-button v-if="hasEditPermission" key="zancun__allinspectionFrom" @click="onSubmitInspection({isCache: 1})" :loading="btnLoading">暂存</el-button>
      <el-button v-if="hasEditPermission" key="submit__allinspectionFrom" @click="onSubmitInspection({isCache: 2})" :loading="btnLoading">提交</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
.module {
  // padding-top: 20px;
  padding: 20px;
  // padding-right: 20%;
  box-shadow: 0 2px 10px rgba(44, 62, 80, 0.3);
  border-radius: 20px;
  color: #101010;
}
.module + .module {
  border-top: 2px solid #EBEEF5;
  margin-top: 20px;
}

.moduleTitle {
  color: #101010;
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 10px;
}

.btns {
  padding-top: 20px;
  button {
    padding: 10px 50px!important;
  }
}

.addAndDelBox {
  margin: 50px 0 30px;
}
.addBtn, .delBtn {
  cursor: pointer;
  i {
    font-size: 25px;
  }
  span {
    color: #888;
    margin-left: 5px;
  }
  &:hover, &:hover span {
    color: #409eff;
  }
}

.addBtn {
  margin-right: 50px;
}
</style>